/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';
import type { BillingQuotaOverride } from './BillingQuotaOverride';
import {
    BillingQuotaOverrideFromJSON,
    BillingQuotaOverrideFromJSONTyped,
    BillingQuotaOverrideToJSON,
    BillingQuotaOverrideToJSONTyped,
} from './BillingQuotaOverride';
import type { BillingProductPrice } from './BillingProductPrice';
import {
    BillingProductPriceFromJSON,
    BillingProductPriceFromJSONTyped,
    BillingProductPriceToJSON,
    BillingProductPriceToJSONTyped,
} from './BillingProductPrice';

/**
 * Represents a companies subscription to a billing plan.
 * @export
 * @interface BillingSubscription
 */
export interface BillingSubscription {
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    billingPackageId: number;
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    downgradeBillingPackageId: number | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof BillingSubscription
     */
    downgradeAt: ShiftiePlainDate | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof BillingSubscription
     */
    startsOn: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof BillingSubscription
     */
    endsOn: ShiftiePlainDate | null;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof BillingSubscription
     */
    trialEndsOn: ShiftiePlainDate | null;
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    billingCycleAnchor: number | null;
    /**
     * 
     * @type {number}
     * @memberof BillingSubscription
     */
    pauseUntil: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillingSubscription
     */
    status: BillingSubscriptionStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof BillingSubscription
     */
    terminatedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof BillingSubscription
     */
    terminationReason: BillingSubscriptionTerminationReasonEnum | null;
    /**
     * 
     * @type {Array<BillingProductPrice>}
     * @memberof BillingSubscription
     */
    billingProductPrices: Array<BillingProductPrice>;
    /**
     * 
     * @type {Array<BillingQuotaOverride>}
     * @memberof BillingSubscription
     */
    billingQuotaOverrides: Array<BillingQuotaOverride>;
}

/**
* @export
* @enum {string}
*/
export enum BillingSubscriptionStatusEnum {
    Active = 'Active',
    Paused = 'Paused',
    Terminated = 'Terminated'
}
/**
* @export
* @enum {string}
*/
export enum BillingSubscriptionTerminationReasonEnum {
    AccountCancelled = 'Account Cancelled',
    BillingFailed = 'Billing Failed',
    CompanyAnonymised = 'Company Anonymised',
    ManuallyTerminated = 'Manually Terminated',
    NewPlan = 'New Plan',
    SubscriptionExpired = 'Subscription Expired',
    TrialEnded = 'Trial Ended'
}


/**
 * Check if a given object implements the BillingSubscription interface.
 */
export function instanceOfBillingSubscription(value: object): value is BillingSubscription {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('billingPackageId' in value) || value['billingPackageId'] === undefined) return false;
    if (!('downgradeBillingPackageId' in value) || value['downgradeBillingPackageId'] === undefined) return false;
    if (!('downgradeAt' in value) || value['downgradeAt'] === undefined) return false;
    if (!('startsOn' in value) || value['startsOn'] === undefined) return false;
    if (!('endsOn' in value) || value['endsOn'] === undefined) return false;
    if (!('trialEndsOn' in value) || value['trialEndsOn'] === undefined) return false;
    if (!('billingCycleAnchor' in value) || value['billingCycleAnchor'] === undefined) return false;
    if (!('pauseUntil' in value) || value['pauseUntil'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('terminatedAt' in value) || value['terminatedAt'] === undefined) return false;
    if (!('terminationReason' in value) || value['terminationReason'] === undefined) return false;
    if (!('billingProductPrices' in value) || value['billingProductPrices'] === undefined) return false;
    if (!('billingQuotaOverrides' in value) || value['billingQuotaOverrides'] === undefined) return false;
    return true;
}

export function BillingSubscriptionFromJSON(json: any): BillingSubscription {
    return BillingSubscriptionFromJSONTyped(json, false);
}

export function BillingSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'billingPackageId': json['billingPackageId'],
        'downgradeBillingPackageId': json['downgradeBillingPackageId'],
        'downgradeAt': ShiftiePlainDateFromJSON(json['downgradeAt']),
        'startsOn': ShiftiePlainDateFromJSON(json['startsOn']),
        'endsOn': ShiftiePlainDateFromJSON(json['endsOn']),
        'trialEndsOn': ShiftiePlainDateFromJSON(json['trialEndsOn']),
        'billingCycleAnchor': json['billingCycleAnchor'],
        'pauseUntil': json['pauseUntil'],
        'status': json['status'],
        'terminatedAt': (json['terminatedAt'] == null ? null : new Date(json['terminatedAt'])),
        'terminationReason': json['terminationReason'],
        'billingProductPrices': ((json['billingProductPrices'] as Array<any>).map(BillingProductPriceFromJSON)),
        'billingQuotaOverrides': ((json['billingQuotaOverrides'] as Array<any>).map(BillingQuotaOverrideFromJSON)),
    };
}

  export function BillingSubscriptionToJSON(json: any): BillingSubscription {
      return BillingSubscriptionToJSONTyped(json, false);
  }

  export function BillingSubscriptionToJSONTyped(value?: BillingSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'billingPackageId': value['billingPackageId'],
        'downgradeBillingPackageId': value['downgradeBillingPackageId'],
        'downgradeAt': ShiftiePlainDateToJSON(value['downgradeAt']),
        'startsOn': ShiftiePlainDateToJSON(value['startsOn']),
        'endsOn': ShiftiePlainDateToJSON(value['endsOn']),
        'trialEndsOn': ShiftiePlainDateToJSON(value['trialEndsOn']),
        'billingCycleAnchor': value['billingCycleAnchor'],
        'pauseUntil': value['pauseUntil'],
        'status': value['status'],
        'terminatedAt': (value['terminatedAt'] == null ? null : (value['terminatedAt'] as any).toISOString()),
        'terminationReason': value['terminationReason'],
        'billingProductPrices': ((value['billingProductPrices'] as Array<any>).map(BillingProductPriceToJSON)),
        'billingQuotaOverrides': ((value['billingQuotaOverrides'] as Array<any>).map(BillingQuotaOverrideToJSON)),
    };
}

